import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=b28163ca&scoped=true&"
import script from "./AreaSelect.vue?vue&type=script&lang=js&"
export * from "./AreaSelect.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=b28163ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28163ca",
  null
  
)

export default component.exports